import React from 'react'

const Cp_bubble = () => {
    return (
        <div className='container'>
            <h1>Bubble Sort</h1>
            <p>Bubble sort is a sorting algorithm that compares two adjacent elements and swaps them if they are not in the intended order.</p>
            <h2>Working of Bubble Sort</h2>
            <p>Suppose we are trying to sort the elements in <strong>ascending order</strong>.</p>
            <p><strong>1. First Iteration (Compare and Swap)</strong></p>
            <ol>
	<li>Starting from the first index, compare the first and the second elements.</li>
	<li>If the first element is greater than the second element, they are swapped.</li>
	<li>Now, compare the second and the third elements. Swap them if they are not in order.</li>
	<li>The above process goes on until the last element.
		<figure><img alt="Compare two adjacent elements and swap them if the first element is greater than the next element" height="502.9" src="//cdn.programiz.com/cdn/farfuture/kn1zM7ZGIj60jcTe3mv8gAtbrvFHqxgqfQ7F9MdjPuA/mtime:1582112622/sites/tutorial2program/files/Bubble-sort-0.png" title="Bubble Sort step 0" width="375"/>
			<figcaption>Compare the Adjacent Elements</figcaption>
		</figure>
	</li>
</ol>
<p><strong>2. Remaining Iteration</strong></p>
<p>The same process goes on for the remaining iterations.</p>
<p>After each iteration, the largest element among the unsorted elements is placed at the end.</p>
<figure><img alt="Continue the swapping and put the largest element among the unsorted list at the end" height="414" src="//cdn.programiz.com/cdn/farfuture/LzbPYkOXS-DjqwLqtIrixMZCD1XLdU-JWWedrL1YIpw/mtime:1582112622/sites/tutorial2program/files/Bubble-sort-1.png" title="Bubble Sort step 1" width="375"/>
	<figcaption>Put the largest element at the end</figcaption>
</figure>
<p>In each iteration, the comparison takes place up to the last unsorted element.</p>
<figure><img alt="Swapping occurs only if the first element is greater than the next element" height="325" src="//cdn.programiz.com/cdn/farfuture/-C5A9EpPrCAwR2TFQlZhG0uy5aSKmq-ewMaWyXp8_a8/mtime:1582112622/sites/tutorial2program/files/Bubble-sort-2.png" title="Bubble Sort step 2" width="375"/>
	<figcaption>Compare the adjacent elements</figcaption>
</figure>
<p>The array is sorted when all the unsorted elements are placed at their correct positions.</p>
<figure><img alt="The array is sorted if all the elements are kept in the right order." height="237" src="//cdn.programiz.com/cdn/farfuture/NnXQeMGuMJnIH0qzC1C5n7r4FOynP9vu3cWEdCK5Qjk/mtime:1582112622/sites/tutorial2program/files/Bubble-sort-3.png" title="Bubble Sort step 3" width="375"/>
	<figcaption>The array is sorted if all elements are kept in the right order</figcaption>
</figure>
<hr/>
<h2>Bubble Sort Code C++</h2>

<div class="containers"><span class="comment">// Bubble sort in C++</span> <br/>
 <br/>
        <span class="meta">#<span class="keywords">include</span> <span class="string">&lt;iostream&gt;</span></span> <br/>
        <span class="keywords">using</span> <span class="keywords">namespace</span> <span class="library">std</span>; <br/>
         <br/>
        <span class="comment">// perform bubble sort</span> <br/>
        <span class="function"><span class="keywords">void</span> <span class="library">bubbleSort</span><span class="params">(<span class="keywords">int</span> <span class="library">array</span>[], <span class="keywords">int</span> size)</span> </span>&#123; <br/>
         <br/>
          <span class="comment">// loop to access each array element</span> <br/>
          <span class="keywords">for</span> (<span class="keywords">int</span> step = <span class="number">0</span>; step &lt; (size<span class="number">-1</span>); ++step) &#123; <br/>
               <br/>
            <span class="comment">// loop to compare array elements</span> <br/>
            <span class="keywords">for</span> (<span class="keywords">int</span> i = <span class="number">0</span>; i &lt; size - (step<span class="number">-1</span>); ++i) &#123; <br/>
         <br/>
              <span class="comment">// compare two adjacent elements</span> <br/>
              <span class="comment">// change &gt; to &lt; to sort in descending order</span> <br/>
              <span class="keywords">if</span> (<span class="library">array</span>[i] &gt; <span class="library">array</span>[i + <span class="number">1</span>]) &#123; <br/>
         <br/>
                <span class="comment">// swapping elements if elements</span> <br/>
                <span class="comment">// are not in the intended order</span> <br/>
                <span class="keywords">int</span> temp = <span class="library">array</span>[i]; <br/>
                <span class="library">array</span>[i] = <span class="library">array</span>[i + <span class="number">1</span>]; <br/>
                <span class="library">array</span>[i + <span class="number">1</span>] = temp; <br/>
              &#125; <br/>
            &#125; <br/>
          &#125; <br/>
        &#125; <br/>
         <br/>
        <span class="comment">// print array</span> <br/>
        <span class="function"><span class="keywords">void</span> <span class="library">printArray</span><span class="params">(<span class="keywords">int</span> <span class="library">array</span>[], <span class="keywords">int</span> size)</span> </span>&#123; <br/>
          <span class="keywords">for</span> (<span class="keywords">int</span> i = <span class="number">0</span>; i &lt; size; ++i) &#123; <br/>
            <span class="library">cout</span> &lt;&lt; <span class="string">"  "</span> &lt;&lt; <span class="library">array</span>[i]; <br/>
          &#125; <br/>
          <span class="library">cout</span> &lt;&lt; <span class="string">"\n"</span>; <br/>
        &#125; <br/>
         <br/>
        <span class="function"><span class="keywords">int</span> <span class="library">main</span><span class="params">()</span> </span>&#123; <br/>
          <span class="keywords">int</span> data[] = &#123;<span class="number">-2</span>, <span class="number">45</span>, <span class="number">0</span>, <span class="number">11</span>, <span class="number">-9</span>&#125;; <br/>
           <br/>
          <span class="comment">// find array's length</span> <br/>
          <span class="keywords">int</span> size = <span class="keywords">sizeof</span>(data) / <span class="keywords">sizeof</span>(data[<span class="number">0</span>]); <br/>
           <br/>
          bubbleSort(data, size); <br/>
           <br/>
          <span class="library">cout</span> &lt;&lt; <span class="string">"Sorted Array in Ascending Order:\n"</span>;   <br/>
          printArray(data, size); <br/>
        &#125; <br/>
</div> <br/>
<h2 id="application">Bubble Sort Applications</h2>
<p>Bubble sort is used if</p>
<ul>
	<li>complexity does not matter</li>
	<li>short and simple code is preferred</li>
</ul>
        </div>
    )
}

export default Cp_bubble
